import React from 'react';
import {ColoredBox} from "./ColoredBox";
import {THEME_SUCCESS} from "../../styles/StyleConstants";
import {AiOutlineFontSize} from "react-icons/ai";


export function IntegratedTerm(props) {

    return (
        <ColoredBox theme={THEME_SUCCESS} title={(
            <div className={"p-0 m-0 d-flex align-items-center"}>
                <AiOutlineFontSize className={"me-2"} size={24}/>
                <p className={"p-0 m-0"}>Begrep</p>
            </div>
        )}>
            <div className={"px-3 pt-2"}>
                <h4>{props.term.term}</h4>
                <p className={"text-justify fw-light"}>{props.term.definition}</p>
            </div>
        </ColoredBox>

    );

}